export default "__VITE_ASSET__C_zklOj7__"